export default __webpack_public_path__ + "static/media/burger.be9de5f0.svg";